import { type MeasurementUnit } from '@/types/measurement';

export const convertInchesToUnit = (value: number, unit: MeasurementUnit): number => {
  switch (unit) {
    case 'mm':
      return value * 25.4;
    case 'cm':
      return value * 2.54;
    default:
      return value;
  }
};

export const convertUnitToInches = (value: number, unit: MeasurementUnit): number => {
  switch (unit) {
    case 'mm':
      return value / 25.4;
    case 'cm':
      return value / 2.54;
    default:
      return value;
  }
};

export const unitPrecision = (unit: MeasurementUnit): number => {
  switch (unit) {
    case 'mm':
      return 0;
    case 'cm':
      return 1;
    default:
      return 2;
  }
};
